import React from 'react';
import { Navigate } from 'react-router-dom';
import { immediateToast } from 'utils/toast';
import { usePermissionChecker } from 'utils/utils';

interface ProtectedRouteProps {
    permissionKey: string;
    fallback?: string;
    condition?: boolean;
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    permissionKey,
    fallback = '/',
    condition = true,
    children,
}) => {
    const { hasPermission } = usePermissionChecker();

    if (!condition || !hasPermission(permissionKey)) {
        immediateToast('error', {
            message: 'شما به این صفحه دسترسی ندارید',
            timeout: 2000,
        });

        return <Navigate to={fallback} />;
    }
    return <>{children}</>;
};
